module.exports = __webpack_public_path__ + "9e33a74b8f9e50df0954150ff811b76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/client/new-session-diamond-pattern@2x.png
// module id = 795
// module chunks = 0